import { BasicConstants, LiveEnvironment } from "@goodgamestudios/core";

export class Poker2Environment extends LiveEnvironment {

    //  dont use this unless we need to deploy a specific version for qa   (and even in that case it would be better to deploy a specific item.props in that S3 branch -  game should always load latest.  to test different versions of item.properties we can use webpack server-proxy
    public USE_TEST_ITEM_JSON: boolean = false;
    public ITEM_VERSION_TO_TEST: number = 1426;

    constructor() {
        CONSTRUCTOR_HACK;
        super("RelativePathsEnvironment");
    }

    public initPatterns(): void {
        this._maintenanceConfigPathPattern = "https://files-ak.goodgamestudios.com/games-config/network/status/1/maint.json";  //TODO HTML-3774
        this._zoneCapacitiesConfigPathPattern = "ARE WE USING IT?"//  BasicConstants.DOMAIN_PROTOCOL + "://{cdnSubDomain}.{domain}/games-config/network/status/{gameId}/zone_capacities.json";
        this._itemsVersionPathPattern = "ItemsVersion.properties";
        this._assetsFolderPathPattern = "assets/";
        this._audiosFolderPathPattern = "assets/sound/";
        this._networkConfigPathPattern = "config/network/{networkId}.xml";
        this._versionPathPattern = "config/version/version.json";
        this._countryConfigPathPattern = "config/country/{countryVersion}/country.xml";
        this._languageConfigPathPattern = "languages/{languageVersion}/{languageCode}.json";
        this._cldrConfigPathPattern = "cldr";
        this._branchesConfigPathPattern = "config/branches/latest/branches.xml";
        this._itemXMLURLPattern = "config/properties/items_v{itemsXMLVersion}.json";

        // TODO HTML5  remove this.   game should always load latest.  to test different versions of item.properties we can use webpack server-proxy
        if (this.USE_TEST_ITEM_JSON) {
            this._itemsVersionPathPattern = "config/properties/" + this.ITEM_VERSION_TO_TEST + "/ItemsVersion.properties";
        } else {
            this._itemsVersionPathPattern = "config/properties/latest/ItemsVersion.properties";
        }

        this._fontsSWFURLPattern = "config/fonts";
        this._fontsSWFURLPatternVersioned = "config/fonts/{languageCode}";//"THIS SHOULD BE TOTALLY USELESS"
        this._shopPathPattern = BasicConstants.DOMAIN_PROTOCOL + "{shopBaseUrl}.goodgamestudios.com/{languageCode}/";
    }

    public isSupported(): boolean {
        return true;
    }

    public get isTestEnvironment(): boolean {
        return this._data.globals.isTest;
    }
}
